import {TableCellEditableInput} from "./editable_controls/TableCellEditableInput";
import {TableCellEditableSelect} from "./editable_controls/TableCellEditableSelect";

import * as styles from "./TableCellEditableControls.module.css";

interface IProps {
    type: "text" | "select" | "number";
    value: number | string;
    options?: {label: string; value: number | string}[];
    minWidth?: string;
    onSave: (newValue: number | string) => void;
    onCancel?: () => void;
}

export const TableCellEditableControls = (props: IProps) => {
    return (
        <div className={styles.cellEditableControls}>
            {props.type === "text" || props.type === "number" ? (
                <TableCellEditableInput type={props.type} value={props.value} minWidth={props.minWidth} onSave={props.onSave} onCancel={props.onCancel} />
            ) : null}
            {props.type === "select" ? <TableCellEditableSelect {...props} /> : null}
        </div>
    );
};
import {TableCellEditableInput} from "./editable_controls/TableCellEditableInput";
import {TableCellEditableSelect} from "./editable_controls/TableCellEditableSelect";

import * as styles from "./TableCellEditableControls.module.css";

interface IProps {
    type: "text" | "select" | "number";
    value: number | string;
    options?: {label: string; value: number | string}[];
    minWidth?: string;
    onSave: (newValue: number | string) => void;
    onCancel?: () => void;
}

export const TableCellEditableControls = (props: IProps) => {
    return (
        <div className={styles.cellEditableControls}>
            {props.type === "text" || props.type === "number" ? (
                <TableCellEditableInput type={props.type} value={props.value} minWidth={props.minWidth} onSave={props.onSave} onCancel={props.onCancel} />
            ) : null}
            {props.type === "select" ? <TableCellEditableSelect {...props} /> : null}
        </div>
    );
};
